import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import './operations.css';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import { useMessageBox } from "../../../../context/MessageBox";
import { ConfirmationBox } from '../../../../components/ConfirmationBox';
import api from "../../../../services/api";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';

function OperationGrid({ gridCabecalho, gridBody, gridTotalizador, gridInfo, setLoadingGrid, onCheckboxChange, selectedItems = [],gridNumber}) {
  const { setMessageData } = useMessageBox();
  const [bodyTable, setBodyTable] = useState();
  const [propertySorted, setPropertySorted] = useState({});
  const [modalBox, setModalBox] = useState({
    show: false,
    htmlText: '',
    titulo: '',
    onlyOneButton: true,
    labelClose: ''
  });
  const [executeBox, setExecuteBox] = useState({
    show: false,
    htmlText: '',
    callback: () => { }
  });
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [showExecuteAlert, setShowExecuteAlert] = useState(false);
  const formatterMoney = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  useEffect(() => {
    if (gridBody) {
      setTable(gridBody);
    }

    // Funções globais para validação em tempo real
    window.checkModalValidation = () => {
      const textarea = document.getElementById('removalReason');
      const charCount = document.getElementById('modalCharCountValue');
      const charCountDiv = document.getElementById('modalCharCount');
      
      if (textarea && charCount) {
        const length = textarea.value.length;
        const maxLength = parseInt(textarea.getAttribute('maxlength')) || 100;
        charCount.textContent = length;
        
        if (length < 20) {
          charCountDiv.style.color = '#f44336'; // Vermelho
        } else if (length > maxLength) {
          charCountDiv.style.color = '#f44336'; // Vermelho se exceder
        } else {
          charCountDiv.style.color = '#4caf50'; // Verde
        }
      }
    };

    window.checkExecuteValidation = () => {
      const textarea = document.getElementById('removalReason');
      const charCount = document.getElementById('executeCharCountValue');
      const charCountDiv = document.getElementById('executeCharCount');
      
      if (textarea && charCount) {
        const length = textarea.value.length;
        const maxLength = parseInt(textarea.getAttribute('maxlength')) || 100;
        charCount.textContent = length;
        
        if (length < 20) {
          charCountDiv.style.color = '#f44336'; // Vermelho
        } else if (length > maxLength) {
          charCountDiv.style.color = '#f44336'; // Vermelho se exceder
        } else {
          charCountDiv.style.color = '#4caf50'; // Verde
        }
      }
    };
  }, [gridBody]);

  const sortTable = (param, index) => {
    setTable(gridBody.sort(dynamicSort(param, index)));
  };

  function dynamicSort(property, index) {
    let sortOrder = 1;
    if (propertySorted[property] !== undefined) {
      sortOrder = propertySorted[property] * -1;
    }
    setPropertySorted(properties => ({ ...properties, [property]: sortOrder }));
    return function (a, b) {
      const result = (a.colunas[index].valorInformacao < b.colunas[index].valorInformacao) ? -1 :
        (a.colunas[index].valorInformacao > b.colunas[index].valorInformacao) ? 1 : 0;
      return result * sortOrder;
    }
  }

  const redirectToScreen = (item) => {
    const eventName = item.eventoMetodo.toLowerCase();
    let dadosParametros = {}
    let dataUrl = ''
    switch (eventName) {
      case 'telaredes':
        dadosParametros = JSON.parse(item.eventoParametro)
        return `/app/visualizar-ancora/${dadosParametros.AncoraId}`
      case 'relatoriodiario':
        dadosParametros = JSON.parse(item.eventoParametro)
        if (dadosParametros.DataReferencia) {
          const dataArray = dadosParametros.DataReferencia.split(' ')[0]
          dataUrl = dataArray.replaceAll('/', '-')
        }
        return `/app/relatorios/diario/${dadosParametros.AncoraId}/${dataUrl}`
      case 'relatoriomensal':
        dadosParametros = JSON.parse(item.eventoParametro)
        if (dadosParametros.DataReferencia) {
          const dataArray = dadosParametros.DataReferencia.split(' ')[0]
          dataUrl = dataArray.replaceAll('/', '-')
        }
        return `/app/relatorios/mensal/${dadosParametros.AncoraId}/${dataUrl}`
      case 'url':
        return item.eventoParametro;
      default:
        return ''
    }
  }

  const canBeLink = (item) => {
    const eventName = item.eventoMetodo.toLowerCase();
    let dadosParametros = {}
    switch (eventName) {
      case 'telaredes':
        dadosParametros = JSON.parse(item.eventoParametro)
        return dadosParametros.AncoraId !== 0 && dadosParametros.AncoraId !== null && dadosParametros.AncoraId !== undefined
      case 'relatoriodiario':
        dadosParametros = JSON.parse(item.eventoParametro)
        return dadosParametros.AncoraId !== 0 && dadosParametros.AncoraId !== null && dadosParametros.AncoraId !== undefined
      case 'relatoriomensal':
        dadosParametros = JSON.parse(item.eventoParametro)
        return dadosParametros.AncoraId !== 0 && dadosParametros.AncoraId !== null && dadosParametros.AncoraId !== undefined
      case 'url':
        return true
      default:
        return false
    }
  }

  const setTable = (data) => {
    setBodyTable(data?.map(function (linha, index) {
      let backColor = 'white';
      if (index % 2) {
        backColor = '#EEEEEE';
      }
      return (
        <>
          <TableRow >
            {linha.colunas?.map(function (item, index) {
              if (item.visivel) {
                if (item.eventoMetodo.toLowerCase() === 'tooltip') {
                  return (
                    <Tooltip key={index} title={tooltipTitleTable(item)} arrow>
                      <TableCell
                        align={item.campoAlinhamentoHorizontal}
                        style={{
                          display: item.visivel ? 'auto' : 'none',
                          cursor: item.eventoMetodo.toLowerCase() !== '' && item.eventoMetodo.toLowerCase() !== 'tooltip' ? 'pointer' : 'auto',
                          color: item.corFonte,
                          backgroundColor: item.corFundo,
                          fontWeight: item.negrito ? 'bold' : '100',
                          minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                          maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                          width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                          left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
                        }}
                        className={item.campoColunaFixa ? 'fixed-column' : ''}
                      >
                        {formatValue(item, true)}
                      </TableCell>
                    </Tooltip>
                  )
                } else if (item.eventoMetodo.toLowerCase() === 'relatoriodiario'
                  || item.eventoMetodo.toLowerCase() === 'relatoriomensal'
                  || item.eventoMetodo.toLowerCase() === 'telaredes'
                  || item.eventoMetodo.toLowerCase() === 'url') {
                  return (
                    <TableCell
                      align={item.campoAlinhamentoHorizontal}
                      style={{
                        display: item.visivel ? 'auto' : 'none',
                        color: item.corFonte,
                        backgroundColor: item.corFundo,
                        fontWeight: item.negrito ? 'bold' : '100',
                        minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
                      }}
                      className={item.campoColunaFixa ? 'fixed-column' : ''}
                    >
                      {canBeLink(item) ? (
                        <Link
                          style={{
                            textDecoration: 'none',
                            color: item.corFonte,
                            backgroundColor: item.corFundo,
                            fontWeight: item.negrito ? 'bold' : '100',
                          }}
                          to={redirectToScreen(item)}
                        >
                          {formatValue(item, true)}
                        </Link>
                      ) : (
                        <>
                          {formatValue(item, true)}
                        </>
                      )}
                    </TableCell>
                  )
                } else {
                  return (
                    <TableCell
                      align={item.campoAlinhamentoHorizontal}
                      style={{
                        display: item.visivel ? 'auto' : 'none',
                        cursor: item.evento === 'OnClick' &&
                          handleCanClick(item.eventoMetodo, item) ? 'pointer' : 'auto',
                        color: item.corFonte,
                        backgroundColor: item.corFundo,
                        fontWeight: item.negrito ? 'bold' : '100',
                        minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
                      }}
                      onClick={() => {
                        if (item.evento === 'OnClick' && handleCanClick(item.eventoMetodo, item)) {
                          handleClickAction(item.eventoMetodo, item)
                        }
                      }}
                      className={item.campoColunaFixa ? 'fixed-column' : ''}
                    >
                      {formatValue(item, true)}
                    </TableCell>
                  )
                }
              }
            })}
          </TableRow>
        </>
      )
    }))
  }

  const toCurrency = (e) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>R$</span>
        <span>{e ? formatterMoney.format(e) : '0,00'}</span>
      </div>
    );
  };

  const formatPorcentage = (e, mascara) => {
    const splitMask = mascara.split('.')
    const toFixedNumber = splitMask[1] ? splitMask[1].length : 0;
    return (
      <>
        <span>{e ? Number(e).toFixed(toFixedNumber) + '%' : mascara + '%'}</span>
      </>
    );
  }

  const formatDecimal = (e, mascara) => {
    const splitMask = mascara.split('.')
    const toFixedNumber = splitMask[1] ? splitMask[1].length : 0;
    return (
      <>
        <span>{e ? Number(e).toFixed(toFixedNumber) : mascara}</span>
      </>
    );
  }

  const formatCurrency = (e) => {
    return (
      <span>{e ? formatterMoney.format(e) : '0,00'}</span>
    );
  };

  const formatDate = (e, mascara) => {
    const splitMask = mascara.split(' ')
    let newMask = mascara
    if (splitMask[0]) {
      splitMask[0] = splitMask[0].toUpperCase()
      let maskTemporary = ''
      splitMask.map((x) => {
        maskTemporary = maskTemporary + x + ' '
      })
      newMask = maskTemporary;
    }
    return (
      <>
        <span>{e ? moment(e).format(newMask ? newMask : 'DD/MM/YYYY') : ' '}</span>
      </>
    );
  }

  const formatDateTime = (e, mascara) => {
    const splitMask = mascara.split(' ')
    let newMask = mascara
    if (splitMask[0]) {
      splitMask[0] = splitMask[0].toUpperCase()
      let maskTemporary = ''
      splitMask.map((x) => {
        maskTemporary = maskTemporary + x + ' '
      })
      newMask = maskTemporary;
    }
    return (
      <>
        <span>{e ? moment(e).format(newMask ? newMask : 'DD/MM/YYYY HH:mm') : ' '}</span>
      </>
    );
  }

  const formatValue = (item, body) => {
    //console.log(item)
    const itemTipo = item.tipo.toLowerCase()
    switch (itemTipo) {
      case 'string':
        return body ? item.valorInformacao : item.totalizadorValor
      case 'integer':
        return body ? item.valorInformacao : item.totalizadorValor
      case 'decimal':
        return formatDecimal(body ? item.valorInformacao : item.totalizadorValor, item.mascara)
      case 'currency':
        formatCurrency(body ? item.valorInformacao : item.totalizadorValor)
      case 'percent':
        return formatPorcentage(body ? item.valorInformacao : item.totalizadorValor, item.mascara)
      case 'money':
        return toCurrency(body ? item.valorInformacao : item.totalizadorValor)
      case 'date':
        return formatDate(body ? item.valorInformacao : item.totalizadorValor, item.mascara)
      case 'datetime':
        return formatDateTime(body ? item.valorInformacao : item.totalizadorValor, item.mascara)
      case 'checkbox':
        return (
          <input 
            type="checkbox"
            checked={selectedItems.includes(item.valorInformacao)}
            onChange={(e) => {
              const isChecked = e.target.checked;
              const itemId = item.valorInformacao;
              if (onCheckboxChange) {
                onCheckboxChange(gridNumber, itemId, isChecked);
              }
            }}
            style={{
              cursor: 'pointer',
              width: '16px',
              height: '16px'
            }}
          />
        );
      default:
        return body ? item.valorInformacao : item.totalizadorValor
    }
  }

  const tableHeaderData = gridCabecalho?.map(function (item, index) {
    if (item.visivel) {
      return (
        <TableCell
          align={item.tituloCampoAlinhamentoHorizontal}
          style={{
            display: item.visivel ? 'auto' : 'none',
            color: item.corFonte,
            backgroundColor: item.corFundo,
            fontWeight: item.negrito ? 'bold' : '100',
            cursor: 'pointer',
            minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
            maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
            width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
            left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
          }}
          onClick={() => sortTable(item.campo, index)}
          className={item.campoColunaFixa ? 'fixed-column' : ''}
        >
          {item.tituloCampo}
        </TableCell>
      )
    }
  })

  const tableTitleColSpan = () => {
    let colSpan = 0
    gridCabecalho?.map(function (item, index) {
      if (item.visivel) {
        colSpan++;
      }
    })
    return colSpan
  }

  const tooltipTitleTable = (item) => {
    return (
      <div dangerouslySetInnerHTML={{ __html: item.eventoParametro }}>
      </div>
    );
  };

  const handleClickAction = (event, item) => {
    
    const eventName = event.toLowerCase();
    let dadosParametro = {}
    switch (eventName) {
      case 'telaoperacao':
        try {
          let cleanString = item.eventoParametro.replace(/(\r\n|\n|\r|\t|\\)/gm, "");
          let cleanedJsonString = cleanString.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
          dadosParametro = JSON.parse(cleanedJsonString)
          window.localStorage.setItem('operationFromReport', JSON.stringify({
            ancoraId: dadosParametro.AncoraId,
            antecipacaoId: dadosParametro.AntecipacaoId,
            fornecedorId: dadosParametro.FornecedorId
          }));
          window.location = '/app/operacao-antecipacao';
        } catch (error) {
          console.error("Nao conseguiu ler o eventoParametro", error);
        }
        break;
      case 'modal':
        try {
          let cleanString = item.eventoParametro.replace(/(\r\n|\n|\r|\t|\\)/gm, "");
          let cleanedJsonString = cleanString.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
          dadosParametro = JSON.parse(cleanedJsonString)
          
          // Debug: ver o que está vindo do backend
          console.log('=== MODAL DEBUG ===');
          console.log('dadosParametro completo:', dadosParametro);
          console.log('Mensagem:', dadosParametro.Mensagem);
          console.log('TipoAcao:', dadosParametro.TipoAcao);
          console.log('Titulo:', dadosParametro.Titulo);
          
          // Remove tags HTML para comparação correta
          const mensagemLimpa = (dadosParametro.Mensagem || '').replace(/<[^>]*>/g, '');
          const tituloLimpo = (dadosParametro.Titulo || '').replace(/<[^>]*>/g, '');
          
          // Verifica se é ação de RECUSAR (Inclusão ou Exclusão)
          // MOSTRA motivo APENAS quando for "Recusar" (seja Inclusão ou Exclusão)
          // NÃO mostra motivo quando for "Confirma" (seja Inclusão ou Exclusão)
          const isRecusar = tituloLimpo.includes('Recusar') || 
                            mensagemLimpa.includes('Recusar');
          
          const shouldShowReason = isRecusar;
          
          console.log('Mensagem Limpa:', mensagemLimpa);
          console.log('É Recusar?', isRecusar);
          console.log('Deve mostrar motivo?', shouldShowReason);
          
          let htmlText = dadosParametro.Mensagem ? dadosParametro.Mensagem : '';
          
          // Ajusta maxlength de 34 para 100
          htmlText = htmlText.replace(/maxlength="34"/g, 'maxlength="100"');
          htmlText = htmlText.replace(/maxlength='34'/g, "maxlength='100'");
          
          // Ajusta formato do contador para "X/100 caracteres" (padrão)
          // Substitui padrões como "Caracteres: <span>0</span>/34" por "<span>0</span>/100 caracteres"
          htmlText = htmlText.replace(
            /Caracteres:\s*<span([^>]*)>(\d+)<\/span>\/\d+/g, 
            '<span$1>$2</span>/100 caracteres'
          );
          htmlText = htmlText.replace(/\/34<\/div>/g, '/100 caracteres</div>');
          htmlText = htmlText.replace(/\/20<\/div>/g, '/100 caracteres</div>');
          
          // Se NÃO deve mostrar motivo, remove o campo de motivo
          if (!shouldShowReason) {
            // Remove qualquer campo de motivo que possa estar no htmlText
            htmlText = htmlText.replace(/<div[^>]*>[\s\S]*?<p[^>]*>Motivo[^<]*:<\/p>[\s\S]*?<textarea[^>]*id="removalReason"[^>]*>[\s\S]*?<\/textarea>[\s\S]*?<div[^>]*id="[^"]*CharCount[^"]*"[^>]*>[\s\S]*?<\/div>[\s\S]*?<\/div>/gi, '');
            // Remove também qualquer div que contenha "Motivo:" sem o campo textarea
            htmlText = htmlText.replace(/<div[^>]*>[\s\S]*?<p[^>]*>Motivo[^<]*:<\/p>[\s\S]*?<\/div>/gi, '');
            // Remove qualquer referência a "Motivo:" no texto
            htmlText = htmlText.replace(/<p[^>]*>Motivo[^<]*:<\/p>/gi, '');
            htmlText = htmlText.replace(/Motivo[^:]*:/gi, '');
            // Remove qualquer textarea com id="removalReason"
            htmlText = htmlText.replace(/<textarea[^>]*id="removalReason"[^>]*>[\s\S]*?<\/textarea>/gi, '');
            // Remove qualquer contador de caracteres
            htmlText = htmlText.replace(/<div[^>]*id="[^"]*CharCount[^"]*"[^>]*>[\s\S]*?<\/div>/gi, '');
          }
          
          setModalBox({
            show: true,
            htmlText: htmlText,
            titulo: dadosParametro.Titulo ? dadosParametro.Titulo : '',
            onlyOneButton: false,
            callback: async () => {
              // Se tem campo de motivo no DOM, valida antes de enviar
              const reasonElement = document.getElementById('removalReason');
              
              // Verifica se é ação de RECUSAR
              const mensagemLimpaCallback = (dadosParametro.Mensagem || '').replace(/<[^>]*>/g, '');
              const tituloLimpoCallback = (dadosParametro.Titulo || '').replace(/<[^>]*>/g, '');
              const isRecusar = tituloLimpoCallback.includes('Recusar') ||
                                mensagemLimpaCallback.includes('Recusar');
              
              if (reasonElement && isRecusar) {
                // Tem campo de motivo E é ação de recusar
                const reason = reasonElement.value.trim();
                if (reason.length < 20) {
                  alert('O motivo precisa ter no mínimo 20 caracteres.');
                  return false; // Não fecha a modal
                }
                if (reason.length > 100) {
                  alert('O motivo não pode ter mais de 100 caracteres.');
                  return false; // Não fecha a modal
                }
                
                // Adiciona o motivo aos parâmetros
                const parametrosComMotivo = {
                  ...dadosParametro.parametro,
                  motivo: reason
                };
                
                await executeGrid(
                  dadosParametro.AcaoInternaId,
                  JSON.stringify(parametrosComMotivo)
                );
              } else {
                // Sem campo de motivo OU não é ação de recusar, executa normalmente
                await executeGrid(
                  dadosParametro.AcaoInternaId,
                  JSON.stringify(dadosParametro.parametro || {})
                );
              }
              return true;
            },
            labelOptional: 'Sim',
            labelClose: 'Não'
          });
        } catch (error) {
          console.error("Nao conseguiu ler o eventoParametro", error);
        }
        break;
      case 'execute':
        try {
          let cleanString = item.eventoParametro.replace(/(\r\n|\n|\r|\t|\\)/gm, "");
          let cleanedJsonString = cleanString.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
          dadosParametro = JSON.parse(cleanedJsonString)

          // Remove tags HTML para comparação correta
          const mensagemLimpa = (dadosParametro.Mensagem || '').replace(/<[^>]*>/g, '');
          const tituloLimpo = (dadosParametro.Titulo || '').replace(/<[^>]*>/g, '');
          
          // Verifica se é ação de RECUSAR (Inclusão ou Exclusão)
          // MOSTRA motivo APENAS quando for "Recusar" (seja Inclusão ou Exclusão)
          const isRecusar = tituloLimpo.includes('Recusar') ||
                            mensagemLimpa.includes('Recusar');
          
          console.log('=== EXECUTE BOX DEBUG ===');
          console.log('Titulo:', dadosParametro.Titulo);
          console.log('Mensagem:', dadosParametro.Mensagem);
          console.log('Mensagem Limpa:', mensagemLimpa);
          console.log('É Recusar?', isRecusar);
          console.log('Parametro (raw):', dadosParametro.parametro);
          console.log('Parametro tipo:', typeof dadosParametro.parametro);
          console.log('Parametro é array?', Array.isArray(dadosParametro.parametro));

          // Monta HTML do campo de motivo APENAS se for ação de RECUSAR
          const campoMotivoHTML = isRecusar ? `
            <div style="margin-top: 15px;">
              <p style="margin-bottom: 5px;">Motivo da Recusa:</p>
              <textarea
                id="removalReason"
                maxlength="100"
                style="width: 95%; height: 60px; padding: 6px; box-sizing: border-box; resize: vertical; font-family: Arial, sans-serif; font-size: 14px;"
                oninput="window.checkExecuteValidation()"
                placeholder="Digite o motivo da recusa (mínimo 20 caracteres)..."
              ></textarea>
              <div id="executeCharCount" style="margin-top: 5px; font-size: 12px; color: #666;">
                <span id="executeCharCountValue">0</span>/100 caracteres
              </div>
            </div>
          ` : '';

          setExecuteBox({
            show: true,
            htmlText: `
        ${dadosParametro.Mensagem ? dadosParametro.Mensagem : ''}
        ${showExecuteAlert && isRecusar ? `
          <div style="margin-top: 15px; padding: 12px; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px; color: #721c24;">
            <strong>⚠️ Erro:</strong> O motivo precisa ter no mínimo 20 caracteres.
          </div>
        ` : ''}
        ${campoMotivoHTML}
      `,
            callback: async () => {
              // Se NÃO é ação de recusar, não precisa validar motivo
              if (!isRecusar) {
                // Executa sem motivo
                let parametros = '';
                if (dadosParametro.parametro) {
                  // Verifica se parametro é array ou objeto
                  if (Array.isArray(dadosParametro.parametro)) {
                    parametros = dadosParametro.parametro.join(';');
                  } else if (typeof dadosParametro.parametro === 'object') {
                    parametros = Object.values(dadosParametro.parametro).join(';');
                  } else {
                    parametros = String(dadosParametro.parametro);
                  }
                }
                console.log('=== CONFIRMAR: Parametros montados ===', parametros);
                await executeGrid(dadosParametro.AcaoInternaId, parametros);
                return true; // Fecha a modal
              }
              
              // Se é "Recusar", valida o motivo
              const reason = document.getElementById('removalReason')?.value.trim();
              if (!reason || reason.length < 20) {
                setShowExecuteAlert(true);
                return false; // Não fecha a modal
              }
              if (reason.length > 100) {
                alert('O motivo não pode ter mais de 100 caracteres.');
                return false; // Não fecha a modal
              }
              setShowExecuteAlert(false);

              // Formata os parâmetros no formato esperado pelo backend (separados por ;)
              let parametros = '';
              if (dadosParametro.parametro) {
                // Pega o primeiro parâmetro (ID do contato)
                let parametroBase = '';
                if (Array.isArray(dadosParametro.parametro)) {
                  parametroBase = dadosParametro.parametro[0] || '';
                } else if (typeof dadosParametro.parametro === 'object') {
                  const valores = Object.values(dadosParametro.parametro);
                  parametroBase = valores[0] || '';
                } else {
                  parametroBase = String(dadosParametro.parametro);
                }
                // Adiciona o motivo como segundo parâmetro
                parametros = `${parametroBase};${reason}`;
              } else {
                // Se não tem parâmetros, usa apenas o motivo
                parametros = reason;
              }

              console.log('=== RECUSAR: Parametros montados ===', parametros);
              await executeGrid(dadosParametro.AcaoInternaId, parametros);
              return true; // Fecha a modal
            }
          });

        } catch (error) {
          console.error("Nao conseguiu ler o eventoParametro", error);
        }

        break;

      default:
        break;
    }
  }

  const handleCanClick = (event, item) => {
    const eventName = event.toLowerCase();
    let dadosParametro = {}
    switch (eventName) {
      case 'telaoperacao':
        dadosParametro = JSON.parse(item.eventoParametro)
        if (dadosParametro.AncoraId &&
          dadosParametro.AntecipacaoId
          && dadosParametro.FornecedorId) {
          return true
        } else {
          return false
        }
      case 'modal':
        return true;
      case 'execute':
        return true;
      default:
        return false;
    }
  }

  const executeGrid = async (acaoInternaId, parametros) => {
   
    console.log('=== DEBUG EXECUTE GRID ===');
    console.log('acaoInternaId:', acaoInternaId);
    console.log('parametros (raw):', parametros);
    console.log('URL completa:', `AcoesInternas/Executar?acaoInternaId=${acaoInternaId}&Parametros=${parametros}`);
   
    setLoadingGrid(true)
    try {
      const executed = await api.get(`AcoesInternas/Executar?acaoInternaId=${acaoInternaId}&Parametros=${parametros}`);

      if (executed?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(executed?.data?.complemento?.mensagensBox);
      }

      if (executed.data.status !== "Sucesso") {
        if (executed.data.resposta) {
          if (executed.data.resposta.length > 0) {
            executed.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      }
    } catch (err) {

    } finally {
      setLoadingGrid(false)
    }

  }

  const tableTotalizadorData = gridTotalizador?.map(function (linha, index) {
    let backColor = '#c4c4c4';
    return (
      <>
        <TableRow >
          {linha.colunas?.map(function (item, index) {
            if (item.visivel) {
              if (item.eventoMetodo.toLowerCase() === 'tooltip') {
                return (
                  <Tooltip key={index} title={tooltipTitleTable(item)} arrow>
                    <TableCell
                      align={item.campoAlinhamentoHorizontal}
                      style={{
                        display: item.visivel ? 'auto' : 'none',
                        color: item.corFonte,
                        backgroundColor: item.corFundo,
                        fontWeight: item.negrito ? 'bold' : '100',
                        minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                        left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
                      }}
                      className={item.campoColunaFixa ? 'fixed-column' : ''}
                    >
                      {formatValue(item, true)}
                    </TableCell>
                  </Tooltip>
                )
              } else if (item.eventoMetodo.toLowerCase() === 'relatoriodiario'
                || item.eventoMetodo.toLowerCase() === 'relatoriomensal'
                || item.eventoMetodo.toLowerCase() === 'telaredes'
                || item.eventoMetodo.toLowerCase() === 'url') {
                return (
                  <TableCell
                    align={item.campoAlinhamentoHorizontal}
                    style={{
                      display: item.visivel ? 'auto' : 'none',
                      cursor: item.eventoMetodo.toLowerCase() !== '' && item.eventoMetodo.toLowerCase() !== 'tooltip' ? 'pointer' : 'auto',
                      color: item.corFonte,
                      backgroundColor: item.corFundo,
                      fontWeight: item.negrito ? 'bold' : '100',
                      minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                      maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                      width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                      left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
                    }}
                    className={item.campoColunaFixa ? 'fixed-column' : ''}
                  >
                    <Link
                      style={{
                        textDecoration: 'none',
                        color: item.corFonte,
                        backgroundColor: item.corFundo,
                        fontWeight: item.negrito ? 'bold' : '100',
                      }}
                      to={redirectToScreen(item)}
                    >
                      {formatValue(item, true)}
                    </Link>
                  </TableCell>
                )
              } else {
                return (
                  <TableCell
                    align={item.campoAlinhamentoHorizontal}
                    style={{
                      display: item.visivel ? 'auto' : 'none',
                      cursor: item.evento === 'OnClick' &&
                        handleCanClick(item.eventoMetodo, item) ? 'pointer' : 'auto',
                      color: item.corFonte,
                      backgroundColor: item.corFundo,
                      fontWeight: item.negrito ? 'bold' : '100',
                      minWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                      maxWidth: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                      width: item.campoTamanhoGrid ? item.campoTamanhoGrid : 'auto',
                      left: item.campoColunaFixa ? `${index * 80}px` : 'auto'
                    }}
                    onClick={() => {
                      if (item.evento === 'OnClick' && handleCanClick(item.eventoMetodo, item)) {
                        handleClickAction(item.eventoMetodo, item)
                      }
                    }}
                    className={item.campoColunaFixa ? 'fixed-column' : ''}
                  >
                    {formatValue(item, true)}
                  </TableCell>
                )
              }
            }
          })}
        </TableRow>
      </>
    )
  })

  return (
    <>
      <div
        id="divOperationGrid"
        className="report-tables"
        style={{
          maxHeight: gridInfo.gridAlturaGrid > 0 ? `${gridInfo.gridAlturaGrid}px` : '495px'

        }}
      >
        <Table
          style={{
            backgroundColor: 'white',
            marginBottom: '20px',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: gridInfo.gridTituloCorFundo }}>
            {gridInfo.gridTitulo && (
              <TableRow>
                <TableCell style={{
                  color: gridInfo.gridTituloCorFonte,
                  fontWeight: gridInfo.gridTituloFonteBold ? 'bold' : 'auto'
                }}
                  align={gridInfo.gridTituloAlinhamentoHorizontal}
                  colSpan={tableTitleColSpan()}>
                  {gridInfo.gridTitulo}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              {tableHeaderData}
            </TableRow>
          </TableHead>
          <TableBody>
            {gridInfo.gridTotalizador.toLowerCase() === 'top' ? (<>
              {tableTotalizadorData}
            </>) : (<></>)}
            {bodyTable}
            {gridInfo.gridTotalizador.toLowerCase() === 'botton' ? (<>
              {tableTotalizadorData}
            </>) : (<></>)}
          </TableBody>
        </Table>
      </div>
      {modalBox.show && (
        <ConfirmationBox
          data={modalBox}
          setConfirmationBox={setModalBox}
        ></ConfirmationBox>
      )}
      {executeBox.show && (
        <ConfirmationBox
          data={executeBox}
          setConfirmationBox={setExecuteBox}
        ></ConfirmationBox>
      )}
    </>
  );
}

export default OperationGrid;